import { moduleProviderFactory } from 'core/providers';
import { PersonEdit, PersonList } from 'application/person/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.person',
                pattern: '/persons',
                children: [
                    {
                        name: 'master.app.main.person.list',
                        pattern: '',
                        tabTitle: 'PERSON.LIST.TITLE',
                        component: PersonList,
                        data: {
                            title: 'PERSON.LIST.TITLE'
                        }
                    },/* 
                    {
                        name: 'master.app.main.person.preview',
                        pattern: '/preview'   ,
                        component: PersonPreview,
                        data: {
                            title: 'PERSON.PREVIEW.TITLE'
                        }
                    }, */
                    {
                        name: 'master.app.main.person.create',
                        pattern: '/create',
                        tabTitle: 'Create Person',
                        component: PersonEdit,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'PERSON.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.person.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'Edit Person',
                        component: PersonEdit,
                        data: {
                            title: 'PERSON.EDIT.TITLE'
                        },
                    }                 
                ]
            }
        ],
        menu : [
            {
                title: 'MENU.ADMINISTRATION',
                order: 10,
                icon: 'users',
                subMenu: [
                    {
                        title: 'MENU.PERSONS',
                        route: 'master.app.main.person.list',
                        order: 2,
                    }                    
                ]
            }
        ]
    });
})();
